(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yy-why-yeti-yogi"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = (track) => {
    if (!track || track.dataset.yyBound === 'true') return;
    track.dataset.yyBound = 'true';

    let active = false;
    let horizontal = false;
    let startX = 0;
    let startY = 0;
    let startScroll = 0;

    const stop = (event) => {
      if (!active) return;
      active = false;
      horizontal = false;
      track.classList.remove('is-dragging');
      try {
        if (event && event.pointerId != null) track.releasePointerCapture(event.pointerId);
      } catch (_) {}
    };

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      active = true;
      horizontal = false;
      startX = event.clientX;
      startY = event.clientY;
      startScroll = track.scrollLeft;
      try { track.setPointerCapture(event.pointerId); } catch (_) {}
    });

    track.addEventListener('pointermove', (event) => {
      if (!active) return;

      const dx = event.clientX - startX;
      const dy = event.clientY - startY;

      if (!horizontal && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
        horizontal = true;
        track.classList.add('is-dragging');
      }

      if (!horizontal) return;

      event.preventDefault();
      track.scrollLeft = startScroll - dx;
    }, { passive: false });

    track.addEventListener('pointerup', stop);
    track.addEventListener('pointercancel', stop);
    track.addEventListener('lostpointercapture', stop);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-yy-why-track]').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yy-yeti-widget-hub"] && !Shopify.designMode) return;
  try {
    
/* Smart Yeti CWV — defer non-critical intelligence until interaction/idle */
(()=>{
  const root=document.getElementById('yy-yeti-widget-hub');
  const data=root?.querySelector('[data-yy-addon-assets]');
  if(!root||!data||root.dataset.addonLoader==='1')return;
  root.dataset.addonLoader='1';

  let urls={};
  try{urls=JSON.parse(data.textContent||'{}')}catch(e){return}

  const seen=new Map();
  const load=(name)=>{
    const src=urls[name];
    if(!src)return Promise.resolve();
    if(seen.has(src))return seen.get(src);

    const p=new Promise((resolve,reject)=>{
      const s=document.createElement('script');
      s.src=src;
      s.async=true;
      s.dataset.yyAddon=name;
      s.onload=resolve;
      s.onerror=reject;
      document.head.appendChild(s);
    });
    seen.set(src,p);
    return p;
  };

  let started=false;
  const start=()=>{
    if(started)return;
    started=true;
    load('catalog')
      .then(()=>load('recommendations'))
      .then(()=>load('analytics'))
      .then(()=>Promise.allSettled([
        load('cart'),load('intent'),load('proactive'),load('cro'),
        load('productAware'),load('pdp')
      ]))
      .catch(()=>{root.dataset.addonLoadPartial='1'});
  };

  // Yeti interactions keep priority: optional modules start as soon as the
  // visitor engages with the assistant, without blocking unrelated navigation.
  root.addEventListener('pointerdown', start, {once:true, passive:true});
  root.addEventListener('touchstart', start, {once:true, passive:true});
  root.addEventListener('keydown', start, {once:true});

  // Keep early shopping journeys responsive: load intelligence as soon as
  // add-to-cart intent is expressed, even if the Yeti assistant was not opened.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target instanceof Element &&
        target.closest('button[name="add"], button[data-add-to-cart], [data-yy-add-to-cart]')) {
      start();
    }
  }, {capture:true, passive:true});
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && /\/cart\/add(?:\.js)?(?:\?|$)/.test(form.action)) {
      start();
    }
  }, {capture:true});

  // Wait until the first page load is complete before scheduling optional
  // modules, so they do not compete with the hero and storefront controls.
  const scheduleOptionalAddons = () => {
    window.setTimeout(() => {
      if (started) return;
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(start, {timeout:4000});
      } else {
        window.setTimeout(start, 1500);
      }
    }, document.body && document.body.classList.contains('template-index') ? 18000 : 6500);
  };
  if (document.readyState === 'complete') scheduleOptionalAddons();
  else window.addEventListener('load', scheduleOptionalAddons, {once:true});
})();

/* Smart Yeti v16 — interaction-first core loader */
/* Smart Yeti v17 — CSS and JS load together on first intent */
(()=>{
  const root=document.getElementById('yy-yeti-widget-hub');
  const fab=root?.querySelector('[data-yy-fab]');
  const scriptSource=root?.dataset.widgetScript||'';
  const styleSource=root?.dataset.widgetStyle||'';
  const compareSource=root?.dataset.widgetCompare||'';
  const postPurchaseSource=root?.dataset.widgetPostpurchase||'';

  if(!root||!fab||!scriptSource||!styleSource||!compareSource||!postPurchaseSource)return;

  let assetPromise=null;
  let replaying=false;

  const setBusy=busy=>{
    fab.toggleAttribute('aria-busy',Boolean(busy));
    root.dataset.coreLoading=busy?'1':'0';
  };

  const loadStyle=()=>{
    if(root.dataset.styleLoaded==='1')return Promise.resolve();

    const existing=document.querySelector('link[data-yy-core-style="1"]');
    if(existing){
      if(existing.dataset.loaded==='1'){
        root.dataset.styleLoaded='1';
        return Promise.resolve();
      }
      return new Promise((resolve,reject)=>{
        existing.addEventListener('load',()=>resolve(),{once:true});
        existing.addEventListener('error',reject,{once:true});
      });
    }

    return new Promise((resolve,reject)=>{
      const link=document.createElement('link');
      link.rel='stylesheet';
      link.href=styleSource;
      link.dataset.yyCoreStyle='1';

      link.addEventListener('load',()=>{
        link.dataset.loaded='1';
        root.dataset.styleLoaded='1';
        resolve();
      },{once:true});

      link.addEventListener('error',()=>{
        root.dataset.styleLoadFailed='1';
        reject(new Error('Yeti styles failed to load'));
      },{once:true});

      document.head.appendChild(link);
    });
  };

  const loadScript=()=>{
    if(root.dataset.scriptLoaded==='1')return Promise.resolve();

    const existing=document.querySelector('script[data-yy-core="1"]');
    if(existing){
      if(existing.dataset.loaded==='1'){
        root.dataset.scriptLoaded='1';
        return Promise.resolve();
      }
      return new Promise((resolve,reject)=>{
        existing.addEventListener('load',()=>resolve(),{once:true});
        existing.addEventListener('error',reject,{once:true});
      });
    }

    return new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src=scriptSource;
      script.async=true;
      script.dataset.yyCore='1';

      script.addEventListener('load',()=>{
        script.dataset.loaded='1';
        root.dataset.scriptLoaded='1';
        resolve();
      },{once:true});

      script.addEventListener('error',()=>{
        root.dataset.scriptLoadFailed='1';
        reject(new Error('Yeti core failed to load'));
      },{once:true});

      document.head.appendChild(script);
    });
  };

  const loadCompare=()=>{
    if(root.dataset.compareLoaded==='1')return Promise.resolve();

    const existing=document.querySelector('script[data-yy-compare-addon="1"]');
    if(existing){
      if(existing.dataset.loaded==='1'){
        root.dataset.compareLoaded='1';
        return Promise.resolve();
      }
      return new Promise((resolve,reject)=>{
        existing.addEventListener('load',resolve,{once:true});
        existing.addEventListener('error',reject,{once:true});
      });
    }

    return new Promise((resolve,reject)=>{
      const script=document.createElement('script');
      script.src=compareSource;
      script.async=true;
      script.dataset.yyCompareAddon='1';

      script.addEventListener('load',()=>{
        script.dataset.loaded='1';
        root.dataset.compareLoaded='1';
        resolve();
      },{once:true});

      script.addEventListener('error',()=>{
        root.dataset.compareLoadFailed='1';
        reject(new Error('Yeti compare add-on failed to load'));
      },{once:true});

      document.head.appendChild(script);
    });
  };

  const loadPostPurchase=()=>{
    if(root.dataset.postPurchaseLoaded==='1')return Promise.resolve();
    return new Promise((resolve,reject)=>{
      const existing=document.querySelector('script[data-yy-postpurchase-addon="1"]');
      if(existing){
        if(existing.dataset.loaded==='1'){root.dataset.postPurchaseLoaded='1';resolve();return;}
        existing.addEventListener('load',resolve,{once:true});
        existing.addEventListener('error',reject,{once:true});
        return;
      }
      const script=document.createElement('script');
      script.src=postPurchaseSource;
      script.async=true;
      script.dataset.yyPostpurchaseAddon='1';
      script.addEventListener('load',()=>{script.dataset.loaded='1';root.dataset.postPurchaseLoaded='1';resolve();},{once:true});
      script.addEventListener('error',()=>{root.dataset.postPurchaseLoadFailed='1';reject(new Error('Yeti post-purchase add-on failed to load'));},{once:true});
      document.head.appendChild(script);
    });
  };

  const loadAssets=()=>{
    if(root.dataset.coreLoaded==='1')return Promise.resolve();
    if(assetPromise)return assetPromise;

    setBusy(true);

    assetPromise=Promise.all([
      loadStyle(),
      loadScript().then(()=>Promise.allSettled([loadCompare(),loadPostPurchase()]))
    ])
      .then(()=>{
        root.classList.add('yy-core-ready');
        root.dataset.coreLoaded='1';
        setBusy(false);
        document.dispatchEvent(new CustomEvent('yeti:core-ready'));
      })
      .catch(error=>{
        setBusy(false);
        root.dataset.coreLoadFailed='1';
        assetPromise=null;
        throw error;
      });

    return assetPromise;
  };

  root.yyLoadAssets=loadAssets;

  const warmAssets=()=>{
    loadAssets().catch(()=>{});
  };

  const insightsRequested=(()=>{
    try{
      return new URLSearchParams(location.search).get('yeti_insights')==='1';
    }catch(e){
      return false;
    }
  })();

  if(insightsRequested){
    loadAssets().catch(()=>{});
  }

  fab.addEventListener('pointerenter',warmAssets,{once:true,passive:true});
  fab.addEventListener('touchstart',warmAssets,{once:true,passive:true});
  fab.addEventListener('focus',warmAssets,{once:true,passive:true});

  fab.addEventListener('click',async event=>{
    if(root.dataset.coreLoaded==='1'||replaying)return;

    event.preventDefault();
    event.stopImmediatePropagation();

    try{
      await loadAssets();
      replaying=true;
      fab.click();
    }catch(error){
      root.dataset.coreLoadFailed='1';
    }finally{
      replaying=false;
    }
  },true);
})();

/* Smart Yeti v17.1 regression hardening */
/* Smart Yeti v11 post-add guidance */
(()=>{
  const init=()=>{
    const root=document.getElementById('yy-yeti-widget-hub');
    if(!root||root.dataset.postAddBound==='1')return;
    root.dataset.postAddBound='1';

    const card=root.querySelector('[data-yy-postadd]');
    const badge=root.querySelector('[data-yy-postadd-badge]');
    const title=root.querySelector('[data-yy-postadd-title]');
    const body=root.querySelector('[data-yy-postadd-body]');
    const primary=root.querySelector('[data-yy-postadd-primary]');
    const close=root.querySelector('[data-yy-postadd-close]');
    const panel=root.querySelector('[data-yy-panel]');
    const chatForm=root.querySelector('[data-yy-chat-form]');
    const chatInput=root.querySelector('[data-yy-chat-input]');

    if(!card||!badge||!title||!body||!primary)return;

    const FREE_SHIPPING=99900;
    const ANALYTICS_KEY='yyYetiAnalyticsV1';
    const initialCount=Number(root.dataset.cartCount||0);
    const initialTotal=Number(root.dataset.cartTotal||0);
    let knownFingerprint='initial:'+initialCount+'@'+initialTotal;
    let pendingTimer=0;
    let checking=false;

    const shopRoot=()=>{
      const value=String(window.Shopify?.routes?.root||'/');
      return value.endsWith('/')?value:value+'/';
    };

    const money=cents=>'₹'+Math.round(Number(cents||0)/100).toLocaleString('en-IN');

    const track=(event,data={})=>{
      const safe={
        event:String(event||'').slice(0,60),
        at:Date.now(),
        pageType:String(root.dataset.pageType||''),
        productHandle:String(data.productHandle||'').slice(0,120),
        handles:[],
        itemCount:Number(data.itemCount||0),
        value:Number(data.value||0),
        source:'post-add',
        status:String(data.status||'').slice(0,40)
      };

      try{
        const parsed=JSON.parse(sessionStorage.getItem(ANALYTICS_KEY)||'{"events":[],"counts":{}}');
        const events=Array.isArray(parsed.events)?parsed.events:[];
        const counts=parsed.counts&&typeof parsed.counts==='object'?parsed.counts:{};
        events.push(safe);
        counts[safe.event]=Number(counts[safe.event]||0)+1;
        sessionStorage.setItem(ANALYTICS_KEY,JSON.stringify({
          events:events.slice(-50),
          counts
        }));
      }catch(e){}

      try{
        if(Array.isArray(window.dataLayer)){
          window.dataLayer.push({
            event:'yeti_widget_event',
            yeti_event:safe.event,
            yeti_item_count:safe.itemCount||undefined,
            yeti_value:safe.value||undefined,
            yeti_source:'post-add',
            yeti_status:safe.status||undefined
          });
        }
      }catch(e){}
    };

    const fetchCart=async()=>{
      try{
        const response=await fetch(shopRoot()+'cart.js',{
          headers:{Accept:'application/json'},
          credentials:'same-origin'
        });
        if(!response.ok)return null;
        return await response.json();
      }catch(e){
        return null;
      }
    };

    const fingerprint=cart=>{
      const items=(cart?.items||[])
        .map(item=>String(item.variant_id||item.id||'')+':'+String(item.quantity||0))
        .sort()
        .join('|');
      return items+'@'+String(cart?.total_price||0);
    };

    const textOfCart=cart=>(cart?.items||[])
      .map(item=>String(item.product_title||item.title||'').toLowerCase())
      .join(' | ');

    const usefulGap=cart=>{
      const text=textOfCart(cart);
      const has=regex=>regex.test(text);

      const yogaMat=has(/yoga mat/)&&!has(/only mat bag/);
      const yogaSupport=has(/yoga block|yoga strap|mat bag/);
      if(yogaMat&&!yogaSupport){
        return {
          label:'Useful yoga pairing',
          message:'Your cart has a yoga mat but no support prop yet. A block or strap can be useful if it matches your practice.',
          prompt:'Check my cart and recommend one useful yoga accessory only if it genuinely complements my current setup. Do not suggest unnecessary products.'
        };
      }

      const pullup=has(/pull.?up bar/);
      const pullupSupport=has(/resistance band|hand gripper|gym glove|wrist wrap/);
      if(pullup&&!pullupSupport){
        return {
          label:'Useful strength pairing',
          message:'Your pull-up setup has no assistance or grip accessory yet. Only add one if it solves a real training need.',
          prompt:'Check my cart and recommend one useful pull-up accessory only if it genuinely helps progression or grip. Do not suggest unnecessary products.'
        };
      }

      const pilates=has(/pilates ring/);
      const pilatesSupport=has(/grip sock|yoga mat|joint comfort pad/);
      if(pilates&&!pilatesSupport){
        return {
          label:'Useful Pilates pairing',
          message:'Your Pilates ring can pair with grip socks or floor support, but only if your sessions need it.',
          prompt:'Check my cart and recommend one useful Pilates pairing only if it genuinely complements the ring. Do not suggest unnecessary products.'
        };
      }

      const roller=has(/foam roller/);
      const recoverySupport=has(/massage ball|acupressure/);
      if(roller&&!recoverySupport){
        return {
          label:'Useful recovery pairing',
          message:'You already have broad recovery covered. A targeted tool only makes sense if you want more focused pressure.',
          prompt:'Check my cart and recommend one targeted recovery add-on only if it adds a different use case from my foam roller.'
        };
      }

      return null;
    };

    const decide=cart=>{
      const total=Number(cart?.total_price||0);
      const count=Number(cart?.item_count||0);
      const gap=Math.max(0,FREE_SHIPPING-total);
      const missing=usefulGap(cart);

      if(!count)return null;

      if(total>=FREE_SHIPPING){
        return {
          state:'ready',
          badge:'YOU’RE SET',
          title:'No more add-ons needed',
          body:'Free shipping unlocked. Quantity + variants check karo, then you’re good to go.',
          label:'Review cart',
          action:'cart',
          status:'stop-shopping'
        };
      }

      if(gap<=30000){
        if(missing){
          return {
            state:'gap',
            badge:'FREE SHIPPING GAP',
            title:money(gap)+' away from free shipping',
            body:missing.message+' Need ho to ek relevant option check kar lo; warna skip it.',
            label:'Check one relevant item',
            action:'recommend',
            prompt:missing.prompt,
            status:'shipping-gap-relevant'
          };
        }

        return {
          state:'gap',
          badge:'FREE SHIPPING GAP',
          title:money(gap)+' away from free shipping',
          body:'You’re close, but nothing extra looks necessary. Free shipping ke liye random item add mat karo.',
          label:'Review cart',
          action:'cart',
          status:'shipping-gap-no-need'
        };
      }

      if(missing&&count<=3){
        return {
          state:'gap',
          badge:'ONE USEFUL CHECK',
          title:missing.label,
          body:missing.message,
          label:'Check one relevant item',
          action:'recommend',
          prompt:missing.prompt,
          status:'useful-gap'
        };
      }

      return {
        state:'ready',
        badge:'CART CHECK',
        title:'Cart looks balanced',
        body:'Cart balanced lag raha hai. Aur add karne ki zarurat nahi — bas review kar lo.',
        label:'Review cart',
        action:'cart',
        status:'balanced'
      };
    };

    const render=(decision,cart)=>{
      if(!decision){
        card.hidden=true;
        return;
      }

      card.classList.toggle('is-ready',decision.state==='ready');
      card.classList.toggle('is-gap',decision.state==='gap');
      badge.textContent=decision.badge;
      title.textContent=decision.title;
      body.textContent=decision.body;
      primary.textContent=decision.label;
      primary.dataset.action=decision.action;
      primary.dataset.prompt=decision.prompt||'';
      primary.dataset.status=decision.status||'';
      card.hidden=false;

      track('post_add_guidance_show',{
        itemCount:Number(cart?.item_count||0),
        value:Number(cart?.total_price||0),
        status:decision.status
      });

      if(panel&&!panel.hidden){
        requestAnimationFrame(()=>{
          card.scrollIntoView({
            behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches?'auto':'smooth',
            block:'nearest'
          });
        });
      }
    };

    const evaluate=async(reason='cart-event')=>{
      if(checking)return;
      checking=true;

      const cart=await fetchCart();
      checking=false;
      if(!cart)return;

      const nextFingerprint=fingerprint(cart);

      if(!knownFingerprint){
        knownFingerprint=nextFingerprint;
        return;
      }

      if(nextFingerprint===knownFingerprint)return;
      knownFingerprint=nextFingerprint;

      render(decide(cart),cart);
    };

    const schedule=(reason='cart-event',delay=450)=>{
      clearTimeout(pendingTimer);
      pendingTimer=setTimeout(()=>evaluate(reason),delay);
    };

    primary.addEventListener('click',async()=>{
      const action=primary.dataset.action||'cart';
      const status=primary.dataset.status||'';

      track('post_add_guidance_action',{
        status,
        source:'post-add'
      });

      if(action==='recommend'){
        const prompt=primary.dataset.prompt
          ||'Check my cart and recommend one genuinely useful missing item only if it complements what I already have. Do not suggest unnecessary products.';

        if(root.dataset.coreLoaded!=='1'&&typeof root.yyLoadAssets==='function'){
          try{
            await root.yyLoadAssets();
          }catch(error){
            location.assign(shopRoot()+'cart');
            return;
          }
        }

        if(chatForm&&chatInput){
          chatInput.value=prompt;
          chatForm.requestSubmit();
          card.hidden=true;
          return;
        }

        const smartButton=root.querySelector('[data-yy-smart-action="cartcheck"],[data-yy-smart-action="recommend"]');
        if(smartButton){
          smartButton.click();
          card.hidden=true;
          return;
        }
      }

      location.assign(shopRoot()+'cart');
    });

    close?.addEventListener('click',()=>{
      card.hidden=true;
      track('post_add_guidance_dismiss',{status:'dismiss'});
    });

    ['cart:updated','cart:refresh','cart:change'].forEach(eventName=>{
      document.addEventListener(eventName,()=>schedule(eventName,250));
    });

    document.addEventListener('submit',event=>{
      const form=event.target?.closest?.('form');
      const action=String(form?.getAttribute?.('action')||'');
      if(action.includes('/cart/add')){
        schedule('cart-form-submit',900);
        setTimeout(()=>schedule('cart-form-submit-late',0),1700);
      }
    },true);

    document.addEventListener('click',event=>{
      const addButton=event.target?.closest?.(
        'button[name="add"],[data-add-to-cart],.m-add-to-cart,[id^="ProductSubmitButton-"]'
      );
      if(addButton&&!addButton.closest('[data-yy-postadd]')){
        schedule('add-click',900);
        setTimeout(()=>schedule('add-click-late',0),1700);
      }
    },true);

  };

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }

})();

/* Smart Yeti v15 — consolidated conversation runtime */
(()=>{
  const initRuntime=()=>{
    const root=document.getElementById('yy-yeti-widget-hub');
    if(!root||root.dataset.runtimeV15Bound==='1')return;
    root.dataset.runtimeV15Bound='1';

    const panel=root.querySelector('[data-yy-panel]');
    const body=root.querySelector('.yy-panel-body--chat');
    const thread=root.querySelector('[data-yy-thread]');
    const typingText=root.querySelector('[data-yy-typing] small');
    if(!panel||!body||!thread)return;

    const currentLang=()=>root.querySelector('[data-yy-lang].is-active')?.dataset.yyLang||'hinglish';
    const copy={
      hinglish:{
        noMatch:'Thoda aur context chahiye — goal ya product type bata do, main shortlist tight kar dunga.',
        budgetNoMatch:'Is budget me strong match nahi mila. Product type ya goal bata do — main better shortlist karunga.',
        noAddon:'Abhi koi genuinely useful add-on nahi mil raha. Better to skip it.',
        noAlternative:'Abhi strong alternative nahi mila. Use-case ya budget bata do, main closer match check karunga.',
        pairing:'Current product/cart ke liye ye relevant pairings hain. Sirf wahi lo jo routine me kaam aaye.',
        alternative:'Ye close alternatives hain. Price + options compare karke choose karo.',
        upgrade:'Ye step-up options hain. Mehenga automatically better nahi hota — specs + use-case dekho.',
        needGoal:'Goal bata do — yoga, strength, recovery, meditation ya home workout?',
        needLevel:'Beginner, regular ya advanced? Isse recommendation better rank hogi.',
        unknown:'Ye detail verified store data me clear nahi hai. Main guess nahi karunga.',
        support:'Iske liye support best rahega — WhatsApp se team help kar degi.'
      },
      en:{
        noMatch:'I need a little more context. Tell me the goal or product type and I’ll narrow it down.',
        budgetNoMatch:'I couldn’t find a strong match in this budget. Tell me the product type or goal and I’ll refine it.',
        noAddon:'I don’t see a genuinely useful add-on right now. Better to skip it.',
        noAlternative:'I couldn’t find a strong alternative yet. Share the use case or budget and I’ll check closer matches.',
        pairing:'These are relevant pairings for your current product/cart. Only add what you’ll actually use.',
        alternative:'These are close alternatives. Compare price and options, then choose what fits.',
        upgrade:'These are step-up options. Higher price doesn’t automatically mean a better fit.',
        needGoal:'What’s your goal — yoga, strength, recovery, meditation, or home workout?',
        needLevel:'Are you a beginner, regular, or advanced? That helps me rank the options better.',
        unknown:'That detail isn’t clearly verified in the store data. I won’t guess.',
        support:'Support is the better route for this. The team can help on WhatsApp.'
      },
      hi:{
        noMatch:'थोड़ा और context चाहिए — goal या product type बताइए, मैं shortlist बेहतर कर दूँगा।',
        budgetNoMatch:'इस budget में strong match नहीं मिला। Product type या goal बताइए, मैं बेहतर shortlist करूँगा।',
        noAddon:'अभी कोई genuinely useful add-on नहीं दिख रहा। इसे skip करना बेहतर है।',
        noAlternative:'अभी strong alternative नहीं मिला। Use-case या budget बताइए, मैं closer match देखूँगा।',
        pairing:'Current product/cart के लिए ये relevant pairings हैं। वही लें जो सच में काम आएँ।',
        alternative:'ये close alternatives हैं। Price और options compare करके चुनें।',
        upgrade:'ये step-up options हैं। ज़्यादा price का मतलब automatically better fit नहीं होता।',
        needGoal:'आपका goal क्या है — yoga, strength, recovery, meditation या home workout?',
        needLevel:'आप beginner, regular या advanced हैं? इससे recommendations बेहतर rank होंगी।',
        unknown:'यह detail verified store data में clear नहीं है। मैं guess नहीं करूँगा।',
        support:'इसके लिए support बेहतर रहेगा — WhatsApp पर team मदद कर देगी।'
      }
    };

    const cleanSentence=text=>String(text||'')
      .replace(/\s+/g,' ')
      .replace(/!{2,}/g,'!')
      .replace(/\?{2,}/g,'?')
      .trim();

    const polish=text=>{
      const original=cleanSentence(text);
      const lower=original.toLowerCase();
      const c=copy[currentLang()]||copy.hinglish;

      if(/is budget ke andar relevant live product confidently nahi mil raha|budget badhane ko force nahi karunga/.test(lower))return c.budgetNoMatch;
      if(/relevant live products abhi confidently shortlist nahi ho rahe|goal ya product type thoda specific/.test(lower))return c.noMatch;
      if(/abhi relevant live recommendation confidently nahi mil rahi|random add-on push nahi karunga/.test(lower))return c.noAddon;
      if(/relevant live alternative abhi confidently shortlist nahi ho raha|random product push nahi karunga/.test(lower))return c.noAlternative;
      if(/current product\/cart ke context me ye useful pairings nikle/.test(lower))return c.pairing;
      if(/ye live alternatives compare kar sakte ho/.test(lower))return c.alternative;
      if(/step-up options ye rahe/.test(lower))return c.upgrade;
      if(/kis goal ke liye chahiye/.test(lower))return c.needGoal;
      if(/aap beginner ho, regular ho ya advanced/.test(lower))return c.needLevel;
      if(/fact confirm nahi hai|fact not confirmed|not clearly available|not confirmed from product data/.test(lower))return c.unknown;
      if(/customer support|whatsapp support|human support/.test(lower)&&/support|whatsapp|agent/.test(lower))return c.support;
      return original;
    };

    const polishBubble=bubble=>{
      if(!bubble||bubble.dataset.yyTonePolished==='1')return;
      if(bubble.closest('.yy-ai-msg')?.classList.contains('yy-ai-msg--user'))return;

      const before=bubble.textContent||'';
      const after=polish(before);
      if(after&&after!==before)bubble.textContent=after;
      bubble.dataset.yyTonePolished='1';
    };

    const editableSelector='input,textarea,select,[contenteditable="true"]';
    const isWidgetEditable=el=>el instanceof Element&&root.contains(el)&&el.matches(editableSelector);
    const reduceMotion=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let followConversation=true;
    let scrollingProgrammatically=false;

    const distanceFromBottom=()=>Math.max(0,body.scrollHeight-body.scrollTop-body.clientHeight);

    const syncKeyboardState=()=>{
      const active=document.activeElement;
      const keyboardOpen=isWidgetEditable(active)&&window.matchMedia('(max-width:749px)').matches;
      panel.classList.toggle('is-keyboard-open',keyboardOpen);

      if(keyboardOpen){
        requestAnimationFrame(()=>{
          active.scrollIntoView({
            behavior:reduceMotion()?'auto':'smooth',
            block:'nearest'
          });
        });
      }
    };

    const scrollToLatest=()=>{
      if(!followConversation||panel.hidden)return;

      scrollingProgrammatically=true;
      requestAnimationFrame(()=>{
        body.scrollTo({
          top:body.scrollHeight,
          behavior:reduceMotion()?'auto':'smooth'
        });
        setTimeout(()=>{scrollingProgrammatically=false;},180);
      });
    };

    body.addEventListener('scroll',()=>{
      if(!scrollingProgrammatically){
        followConversation=distanceFromBottom()<140;
      }
    },{passive:true});

    root.addEventListener('focusin',event=>{
      if(isWidgetEditable(event.target))syncKeyboardState();

      if(event.target.matches?.('[data-yy-chat-input]')){
        followConversation=true;
        setTimeout(scrollToLatest,80);
      }
    });

    root.addEventListener('focusout',()=>{
      setTimeout(syncKeyboardState,120);
    });

    root.addEventListener('click',event=>{
      const langButton=event.target.closest('[data-yy-lang]');

      if(langButton&&typingText){
        const lang=langButton.dataset.yyLang||'hinglish';
        typingText.textContent=lang==='hi'?'Yeti देख रहा है…':lang==='en'?'Yeti checking…':'Yeti check kar raha hai…';
      }

      if(event.target.closest('[data-yy-thread] button,[data-yy-thread] a')){
        followConversation=true;
      }
    },{passive:true});

    window.visualViewport?.addEventListener('resize',()=>{
      if(!window.matchMedia('(max-width:749px)').matches)return;

      const viewport=window.visualViewport;
      if(!viewport)return;

      const keyboardLikely=window.innerHeight-viewport.height>140&&isWidgetEditable(document.activeElement);
      panel.classList.toggle('is-keyboard-open',keyboardLikely);
    },{passive:true});

    const observer=new MutationObserver(records=>{
      let shouldScroll=false;

      for(const record of records){
        for(const node of record.addedNodes||[]){
          if(!(node instanceof Element))continue;

          if(node.matches?.('.yy-ai-msg--yeti .yy-ai-msg__bubble')){
            polishBubble(node);
          }

          node.querySelectorAll?.('.yy-ai-msg--yeti .yy-ai-msg__bubble').forEach(polishBubble);

          if(
            node.matches?.('.yy-ai-msg,.yy-ai-products,.yy-smart-bundle')||
            node.querySelector?.('.yy-ai-msg,.yy-ai-products,.yy-smart-bundle')
          ){
            shouldScroll=true;
          }
        }
      }

      if(shouldScroll)scrollToLatest();
    });

    observer.observe(thread,{childList:true,subtree:true});
    thread.querySelectorAll('.yy-ai-msg--yeti .yy-ai-msg__bubble').forEach(polishBubble);

    document.addEventListener('yeti:analytics',event=>{
      if(event?.detail?.event==='recommendation_impression'){
        root.dataset.lastRecommendationAt=String(Date.now());
      }
    },{passive:true});

    syncKeyboardState();
  };

  const startRuntime=()=>{
    const root=document.getElementById('yy-yeti-widget-hub');

    if(root?.dataset.coreLoaded==='1'){
      initRuntime();
      return;
    }

    document.addEventListener('yeti:core-ready',initRuntime,{once:true});
  };

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',startRuntime,{once:true});
  }else{
    startRuntime();
  }
})();
  } catch(e) { console.error(e); }
})();
})();
